var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{ref:"point",class:{ 'avue-affix': _vm.affix },style:(_vm.styles)},[_vm._t("default")],2),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.slot),expression:"slot"}],style:(_vm.slotStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }